import { render, staticRenderFns } from "./TaxYN.vue?vue&type=template&id=77813e60"
import script from "./TaxYN.vue?vue&type=script&lang=js"
export * from "./TaxYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports